module.exports = __webpack_public_path__ + "img/mannul_transactions_dateil.c43f184c.png";